export enum PROVIDER_STATUS {
    ACTIVE = 'ACTIVE',
    POSSIBLE = 'INACTIVE_POSSIBLE',
    CANCELLED = 'INACTIVE_CANCELLED',
    INACTIVE = 'INACTIVE'
}

export enum PROVIDER_STATUS_TAGS {
    ACTIVE = 'Activo',
    POSSIBLE = 'Posible',
    CANCELLED = 'Cancelado',
    INACTIVE = 'Inactivo'
}


